import { html } from 'htm/preact';

const SelectSimple = ({ placeholder, name, disabled, options, onChange, required = false }) => {
  return html`
    <div class="relative w-full max-w-72">
      <select
        name=${name}
        class="rounded-lg text-sm border bg-white border-gray-200 px-3 md:px-4 py-2 cursor-pointer max-w-72 h-14 appearance-none peer disabled:opacity-50 disabled:cursor-not-allowed w-full"
        disabled=${disabled}
        onChange=${(e) => (onChange ? onChange(e.target.value) : null)}
        required=${required}
      >
        <option value="" selected>${placeholder}</option>
        ${options.map((option) => html`<option value=${option.value}>${option.label}</option>`)}
      </select>
      <div
        class="pointer-events-none absolute top-1/2 right-0 -translate-y-1/2 px-3 py-2 border-l border-gray-200 text-purple peer-disabled:opacity-50"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="currentColor">
          <path
            d="M7.29808 8.94293C6.89798 9.47287 6.10202 9.47287 5.70192 8.94293L0.348702 1.85255C-0.148711 1.19372 0.321269 0.25 1.14678 0.25H11.8532C12.6787 0.25 13.1487 1.19372 12.6513 1.85255L7.29808 8.94293Z"
          />
        </svg>
      </div>
    </div>
  `;
};

export default SelectSimple;
